import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';

const container = document.getElementById('orbs-app');
if (container) {
  createRoot(container).render(<App />);
}
